import React from 'react'
import {Redirect} from 'react-router-dom'
import Dialog from 'material-ui-legacy/Dialog'
import Snackbar from 'material-ui-legacy/Snackbar'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import DoneButton from '../UI/DoneButton'
import ReferenceValueForm from './ReferenceValueForm'
import ReferenceValueCard from './ReferenceValueCard'

import Resource from '../../stores/resource'
const ReferenceValueStore = Resource('reference-values')

class NewReferenceValue extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      referenceValue: (this.props.attributes || {}),
      saved: false,
      error: '',
      snackbarMessage: '',
      redirect: null
    }
  }

  _save = (attributes) => {
    ReferenceValueStore.create(attributes)
    .then((result) => {
      this.setState({
        saved: true,
        error: '',
        savedReferenceValue: result.data.data,
        snackbarMessage: `ReferenceValue "${attributes.name}" created!`
      },
      () => {
        if (this.props.savedCallback) {
          this.props.savedCallback(this.state.savedReferenceValue)
        }
      })
    })
    .catch((error) => {
      this.setState({
        saved: false,
        error: errors.unpack(error)
      })
    })
  }

  _closeErrorDialog = () => this.setState({error: ''})

  _closeSuccessDialog = () => this.setState({redirect: `/reference-values`})

  _resetSnackbar = () => this.setState({snackbarMessage: ''})

  _redirectTo = (url) => this.setState({redirect: url})

  render() {
    if (this.state.redirect) return <Redirect push to={this.state.redirect}/>

    const referenceValue = this.state.referenceValue
    const saved = this.state.saved

    const successDialogActions = [
      <DoneButton onTouchTap={this._closeSuccessDialog}/>
    ]

    return (
      <section>
        <ReferenceValueForm
          formTitle={this.props.formTitle}
          name={referenceValue.name}
          valueType={referenceValue.valueType}
          value={referenceValue.value}
          forceChanged={this.props.forceChanged}
          submitCallback={this._save}
          cancelCallback={this.props.cancelCallback}
        />
        <br/>

        <ErrorDialog
          open={Boolean(this.state.error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't create reference value">
          <p>
            <strong>Error:</strong> {this.state.error}
          </p>
        </ErrorDialog>

        <Snackbar
          open={Boolean(this.state.snackbarMessage)}
          message={this.state.snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        {/* Success dialog */}
        {saved && this.props.showSuccessDialog &&
          <Dialog
            actions={successDialogActions}
            modal={false}
            onRequestClose={this._closeSuccessDialog}
            open={Boolean(this.state.saved)}
            title="ReferenceValue created">
            <p>
              A new reference value has been created with the information below.<br/>
              If you see any incorrect information, press the <strong>Edit</strong> button.
            </p>
            <ReferenceValueCard
              referenceValue={this.state.savedReferenceValue}
              editCallback={() => this._redirectTo(`/reference-values/${this.state.savedReferenceValue.id}/edit`)}
            />
          </Dialog>
        }
      </section>
    )
  }
}

export default NewReferenceValue



// WEBPACK FOOTER //
// ./src/components/ReferenceValues/NewReferenceValue.jsx